import { IteroOrderDetails, IteroProposalClient } from 'types';

export const isProposalContainsSubscription = (
  proposal: IteroProposalClient
) => {
  return (
    proposal.lineitems.filter(item => item.subscriptions?.length > 0).length > 0
  );
};

export const isScannerUpgradeProposal = (proposal: IteroProposalClient) => {
  return proposal.processType === 'Upgrade';
};

export const shouldShowServicePlanDetails = (proposal: IteroProposalClient) => {
  return (
    !isScannerUpgradeProposal(proposal) &&
    isProposalContainsSubscription(proposal)
  );
};

export const getServicePlanFee = (
  order: IteroOrderDetails | IteroProposalClient | null | undefined
): string | undefined => {
  return order?.lineitems?.[0]?.subscriptions?.[0]?.displayItemUnitPrice;
};
